export function initCreatePassword(): void {
  const passwordValid: { createPassword: boolean; confirmPassword: boolean } = {
    createPassword: false,
    confirmPassword: false,
  };

  createPassword(passwordValid);
  confirmPassword(passwordValid);

  // Listen for validation changes and update submit button
  const submitButton = document.querySelector<HTMLButtonElement>('.authentication-form__submit-create');
  if (submitButton) {
    document.addEventListener('passwordValidationChange', ((e: CustomEvent) => {
      const { passwordValid } = e.detail;
      submitButton.disabled = !(passwordValid.createPassword && passwordValid.confirmPassword);
    }) as EventListener);
  }
}

function createPassword(passwordValid: { createPassword: boolean; confirmPassword: boolean }): void {
  const createPasswordContainers = document.querySelectorAll<HTMLElement>('[data-component="create-password"]');

  createPasswordContainers.forEach(container => {
    const passwordInput = container.querySelector<HTMLInputElement>('.authentication-form__input--create-password');
    const passwordRequirements = container.querySelector<HTMLElement>('.authentication-form__password-requirements');
    const requirementsList = container.querySelectorAll<HTMLElement>(
      '.authentication-form__password-requirements-item'
    );

    if (!passwordInput || !passwordRequirements || requirementsList.length === 0) return;

    function validatePassword() {
      const value = passwordInput.value;
      let isValid = true;
      // Check for length 8-12 and no forward slash
      if (value.length >= 8 && value.length <= 12 && !value.includes('/')) {
        requirementsList[0].classList.add('valid');
      } else {
        requirementsList[0].classList.remove('valid');
        isValid = false;
      }
      // Check for at least one uppercase letter and one special character
      const hasUpperCase = /[A-Z]/.test(value);
      const hasSpecialChar = /[!@#$%^&*_\-+=?<>.,\\|`~()[\]{}]/.test(value);
      if (hasUpperCase && hasSpecialChar) {
        requirementsList[1].classList.add('valid');
      } else {
        requirementsList[1].classList.remove('valid');
        isValid = false;
      }
      if (isValid) {
        passwordRequirements.style.display = 'none';
        passwordValid.createPassword = true;
      } else {
        passwordRequirements.style.display = 'block';
        passwordValid.createPassword = false;
      }

      document.dispatchEvent(
        new CustomEvent('passwordValidationChange', {
          detail: { passwordValid },
        })
      );
    }
    passwordInput.addEventListener('input', validatePassword);
    passwordInput.addEventListener('blur', validatePassword);
  });
}

function confirmPassword(passwordValid: { createPassword: boolean; confirmPassword: boolean }): void {
  const confirmPasswordContainers = document.querySelectorAll<HTMLElement>('[data-component="confirm-password"]');

  confirmPasswordContainers.forEach(container => {
    const passwordInput = container.parentElement.querySelector<HTMLInputElement>(
      '.authentication-form__input--create-password'
    );
    const confirmPasswordInput = container.querySelector<HTMLInputElement>(
      '.authentication-form__input--create-confirm-password'
    );
    const confirmPasswordMessage = container.querySelector<HTMLElement>(
      '.authentication-form__validation--create-confirm-password'
    );

    if (!passwordInput || !confirmPasswordInput || !confirmPasswordMessage) return;

    // Track whether user has interacted with the confirm password field
    let confirmPasswordTouched = false;

    function validateConfirmPassword(showError: boolean = true) {
      const passwordsMatch = confirmPasswordInput.value === passwordInput.value;

      if (passwordsMatch) {
        passwordValid.confirmPassword = true;
        confirmPasswordMessage.style.display = 'none';
        confirmPasswordMessage.classList.remove('field-validation-error');
      } else {
        passwordValid.confirmPassword = false;
        // Only show the error if the confirm password field has been touched
        if (showError && confirmPasswordTouched) {
          confirmPasswordMessage.style.display = 'block';
          confirmPasswordMessage.classList.add('field-validation-error');
        }
      }

      document.dispatchEvent(
        new CustomEvent('passwordValidationChange', {
          detail: { passwordValid },
        })
      );
    }

    // When the first password changes, validate but only show error if confirm was already touched
    passwordInput.addEventListener('input', () => validateConfirmPassword(confirmPasswordTouched));
    passwordInput.addEventListener('blur', () => validateConfirmPassword(confirmPasswordTouched));

    // Mark as touched when user interacts with confirm password field
    confirmPasswordInput.addEventListener('input', () => {
      confirmPasswordTouched = true;
      validateConfirmPassword(true);
    });
    confirmPasswordInput.addEventListener('blur', () => {
      confirmPasswordTouched = true;
      validateConfirmPassword(true);
    });
  });
}

// Auto-initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCreatePassword);
} else {
  initCreatePassword();
}
